'use client';

import { c as _c } from "react/compiler-runtime";
import { DOCS__PERMISSIONS } from '@algoacademy/backend/modules/docs/permissions';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { PencilIcon } from '@heroicons/react/16/solid';
import { useParams } from 'next/navigation';
import { useAuth } from '@/app/_auth/useAuth';
import { useCollectionStructure } from '@/app/baza/(collection)/_utils/CollectionStructureContext/CollectionStructureContext';
type NavbarMobileManageCollectionButtonProps = {
  onNavigate?: () => void;
};
export function NavbarMobileManageCollectionButton(t0) {
  const $ = _c(4);
  const {
    onNavigate
  } = t0;
  const {
    collectionSlug
  } = useParams();
  const {
    collection
  } = useCollectionStructure();
  const {
    user
  } = useAuth();
  if (!collection) {
    return null;
  }
  const userCanManageCollection = collection.canManage === true && user.hasPermissions([DOCS__PERMISSIONS.KNOWLEDGE_BASE.MANAGE.ASSIGNED]) || user.hasPermissions([DOCS__PERMISSIONS.KNOWLEDGE_BASE.MANAGE.ALL]);
  if (!userCanManageCollection) {
    return null;
  }
  const t1 = `/baza/${collectionSlug}/manage`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PencilIcon />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onNavigate || $[2] !== t1) {
    t3 = <Button outline={true} href={t1} className="w-full" onClick={onNavigate}>{t2}Zarządzaj kolekcją</Button>;
    $[1] = onNavigate;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}